module.exports = __webpack_public_path__ + "media/Audio15_d.a27a0872.wav";